/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-09-24 17:46:25
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Button } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import SendRequestModal from 'src/components/containers/common/send-request-modal';

type Props = {
  currentTotalProducts: number,
  price: number,
  totalProducts: number,
  correctPlan: Object,
  selectPlanProducts: number,
  verify: Function,
  loading: boolean,
  subscribe: Function,
  planId: string,
  showVerifyCodeNotice: boolean,
  code: string
};

type ComposedProps = Props & WithI18nProps;

type State = {
  activeRequest: boolean
};

class PriceBoxLargePlan extends Component<ComposedProps, State> {
  state = {
    activeRequest: false
  };

  render() {
    const { i18n } = this.props;
    return (
      <div className="priceBox">
        <div className="priceLarge">
          <span>{i18n.translate('AdminHTML.Subscription.PriceBoxLargePlan.title')}</span>
        </div>

        <div className="description">
          {i18n.translate('AdminHTML.Subscription.PriceBoxLargePlan.content', {
            t1: (
              <strong>
                {i18n.translate('AdminHTML.Subscription.PriceBoxLargePlan.content_t1')}
              </strong>
            )
          })}
        </div>

        <Button primary onClick={this.sendRequest}>
          {i18n.translate('AdminHTML.Subscription.PriceBoxLargePlan.request')}
        </Button>

        <div className="warning">{''}</div>

        <SendRequestModal
          active={this.state.activeRequest}
          handleChange={() => this.toggleChangeState('activeRequest')}
        />
      </div>
    );
  }

  // send Request
  sendRequest = () => {
    this.toggleChangeState('activeRequest');
  };

  // Toggle change state
  toggleChangeState = (id: string) => {
    const value = this.state[id];
    this.setState({ [id]: !value });
  };
}

export default withI18n()(PriceBoxLargePlan);
